import { render, staticRenderFns } from "./ModalEditOffert.vue?vue&type=template&id=6ed8c4c5&scoped=true&"
import script from "./ModalEditOffert.vue?vue&type=script&lang=js&"
export * from "./ModalEditOffert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed8c4c5",
  null
  
)

export default component.exports